exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#textPrivacidade{text-align:left}.display-2{text-align:center}", "", {"version":3,"sources":["C:/Users/chris/projetos/prepago/src/components/Removerconta.vue"],"names":[],"mappings":"AACA,iBACE,eAAiB,CAClB,AACD,WACE,iBAAmB,CACpB","file":"Removerconta.vue","sourcesContent":["\n#textPrivacidade {\r\n  text-align: left;\n}\n.display-2 {\r\n  text-align: center;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6022a470","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Removerconta.vue
// module id = 662
// module chunks = 4